const loadEversign = (callback) => {
  const existingScript = document.getElementById("esign");
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = "https://static.eversign.com/js/embedded-signing.js";
    script.id = "esign";
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};
export default loadEversign;
